var _line, _line2, _line3, _line4, _line5, _line6, _line7, _line8, _line9, _line10, _line11, _line12, _line13, _line14, _line15, _line16, _line17, _line18, _line19, _line20, _line21, _line22, _line23, _line24, _line25, _line26, _line27, _line28, _line29, _line30, _line31, _line32, _line33, _line34, _line35, _line36, _line37, _line38, _line39, _line40, _line41, _line42, _line43, _line44, _line45, _line46, _line47, _line48, _line49, _line50, _line51, _line52, _line53, _line54, _line55, _line56, _line57, _line58, _line59, _line60, _line61, _line62, _line63, _line64, _line65, _line66, _line67, _line68, _line69, _line70, _line71, _line72, _line73, _line74, _line75, _line76, _line77, _line78, _line79, _line80, _line81, _line82, _line83, _line84, _line85, _line86, _line87, _line88, _line89, _line90;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLongTimeline(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 409,
    height: 3183,
    viewBox: "0 0 409 3183",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _line || (_line = /*#__PURE__*/React.createElement("line", {
    opacity: 0.1,
    x1: 409,
    y1: 1.5,
    x2: 374,
    y2: 1.5,
    stroke: "#120232",
    strokeWidth: 3
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    opacity: 0.1,
    x1: 409,
    y1: 36.5,
    x2: 389,
    y2: 36.5,
    stroke: "#120232",
    strokeWidth: 3
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    opacity: 0.1,
    x1: 409,
    y1: 71.5,
    x2: 389,
    y2: 71.5,
    stroke: "#120232",
    strokeWidth: 3
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    opacity: 0.1,
    x1: 409,
    y1: 106.5,
    x2: 389,
    y2: 106.5,
    stroke: "#120232",
    strokeWidth: 3
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    opacity: 0.1,
    x1: 409,
    y1: 141.5,
    x2: 389,
    y2: 141.5,
    stroke: "#120232",
    strokeWidth: 3
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    opacity: 0.1,
    x1: 409,
    y1: 176.5,
    x2: 343,
    y2: 176.5,
    stroke: "#6013FB",
    strokeWidth: 3
  })), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    opacity: 0.1,
    x1: 409,
    y1: 211.5,
    x2: 389,
    y2: 211.5,
    stroke: "#120232",
    strokeWidth: 3
  })), _line8 || (_line8 = /*#__PURE__*/React.createElement("line", {
    opacity: 0.1,
    x1: 409,
    y1: 246.5,
    x2: 389,
    y2: 246.5,
    stroke: "#120232",
    strokeWidth: 3
  })), _line9 || (_line9 = /*#__PURE__*/React.createElement("line", {
    opacity: 0.1,
    x1: 409,
    y1: 281.5,
    x2: 389,
    y2: 281.5,
    stroke: "#120232",
    strokeWidth: 3
  })), _line10 || (_line10 = /*#__PURE__*/React.createElement("line", {
    opacity: 0.1,
    x1: 409,
    y1: 316.5,
    x2: 389,
    y2: 316.5,
    stroke: "#120232",
    strokeWidth: 3
  })), _line11 || (_line11 = /*#__PURE__*/React.createElement("line", {
    opacity: 0.1,
    x1: 409,
    y1: 351.5,
    x2: 374,
    y2: 351.5,
    stroke: "#120232",
    strokeWidth: 3
  })), _line12 || (_line12 = /*#__PURE__*/React.createElement("line", {
    opacity: 0.1,
    x1: 409,
    y1: 386.5,
    x2: 389,
    y2: 386.5,
    stroke: "#120232",
    strokeWidth: 3
  })), _line13 || (_line13 = /*#__PURE__*/React.createElement("line", {
    opacity: 0.1,
    x1: 409,
    y1: 421.5,
    x2: 389,
    y2: 421.5,
    stroke: "#120232",
    strokeWidth: 3
  })), _line14 || (_line14 = /*#__PURE__*/React.createElement("line", {
    opacity: 0.1,
    x1: 409,
    y1: 456.5,
    x2: 389,
    y2: 456.5,
    stroke: "#120232",
    strokeWidth: 3
  })), _line15 || (_line15 = /*#__PURE__*/React.createElement("line", {
    opacity: 0.1,
    x1: 409,
    y1: 491.5,
    x2: 389,
    y2: 491.5,
    stroke: "#120232",
    strokeWidth: 3
  })), _line16 || (_line16 = /*#__PURE__*/React.createElement("line", {
    opacity: 0.1,
    x1: 409,
    y1: 539.5,
    x2: 374,
    y2: 539.5,
    stroke: "#120232",
    strokeWidth: 3
  })), _line17 || (_line17 = /*#__PURE__*/React.createElement("line", {
    opacity: 0.1,
    x1: 409,
    y1: 574.5,
    x2: 389,
    y2: 574.5,
    stroke: "#120232",
    strokeWidth: 3
  })), _line18 || (_line18 = /*#__PURE__*/React.createElement("line", {
    opacity: 0.1,
    x1: 409,
    y1: 609.5,
    x2: 389,
    y2: 609.5,
    stroke: "#120232",
    strokeWidth: 3
  })), _line19 || (_line19 = /*#__PURE__*/React.createElement("line", {
    opacity: 0.1,
    x1: 409,
    y1: 644.5,
    x2: 389,
    y2: 644.5,
    stroke: "#120232",
    strokeWidth: 3
  })), _line20 || (_line20 = /*#__PURE__*/React.createElement("line", {
    opacity: 0.1,
    x1: 409,
    y1: 679.5,
    x2: 389,
    y2: 679.5,
    stroke: "#120232",
    strokeWidth: 3
  })), _line21 || (_line21 = /*#__PURE__*/React.createElement("line", {
    opacity: 0.1,
    x1: 409,
    y1: 714.5,
    x2: 343,
    y2: 714.5,
    stroke: "#6013FB",
    strokeWidth: 3
  })), _line22 || (_line22 = /*#__PURE__*/React.createElement("line", {
    opacity: 0.1,
    x1: 409,
    y1: 749.5,
    x2: 389,
    y2: 749.5,
    stroke: "#120232",
    strokeWidth: 3
  })), _line23 || (_line23 = /*#__PURE__*/React.createElement("line", {
    opacity: 0.1,
    x1: 409,
    y1: 784.5,
    x2: 389,
    y2: 784.5,
    stroke: "#120232",
    strokeWidth: 3
  })), _line24 || (_line24 = /*#__PURE__*/React.createElement("line", {
    opacity: 0.1,
    x1: 409,
    y1: 819.5,
    x2: 389,
    y2: 819.5,
    stroke: "#120232",
    strokeWidth: 3
  })), _line25 || (_line25 = /*#__PURE__*/React.createElement("line", {
    opacity: 0.1,
    x1: 409,
    y1: 854.5,
    x2: 389,
    y2: 854.5,
    stroke: "#120232",
    strokeWidth: 3
  })), _line26 || (_line26 = /*#__PURE__*/React.createElement("line", {
    opacity: 0.1,
    x1: 409,
    y1: 889.5,
    x2: 374,
    y2: 889.5,
    stroke: "#120232",
    strokeWidth: 3
  })), _line27 || (_line27 = /*#__PURE__*/React.createElement("line", {
    opacity: 0.1,
    x1: 409,
    y1: 924.5,
    x2: 389,
    y2: 924.5,
    stroke: "#120232",
    strokeWidth: 3
  })), _line28 || (_line28 = /*#__PURE__*/React.createElement("line", {
    opacity: 0.1,
    x1: 409,
    y1: 959.5,
    x2: 389,
    y2: 959.5,
    stroke: "#120232",
    strokeWidth: 3
  })), _line29 || (_line29 = /*#__PURE__*/React.createElement("line", {
    opacity: 0.1,
    x1: 409,
    y1: 994.5,
    x2: 389,
    y2: 994.5,
    stroke: "#120232",
    strokeWidth: 3
  })), _line30 || (_line30 = /*#__PURE__*/React.createElement("line", {
    opacity: 0.1,
    x1: 409,
    y1: 1029.5,
    x2: 389,
    y2: 1029.5,
    stroke: "#120232",
    strokeWidth: 3
  })), _line31 || (_line31 = /*#__PURE__*/React.createElement("line", {
    opacity: 0.1,
    x1: 409,
    y1: 1077.5,
    x2: 374,
    y2: 1077.5,
    stroke: "#120232",
    strokeWidth: 3
  })), _line32 || (_line32 = /*#__PURE__*/React.createElement("line", {
    opacity: 0.1,
    x1: 409,
    y1: 1112.5,
    x2: 389,
    y2: 1112.5,
    stroke: "#120232",
    strokeWidth: 3
  })), _line33 || (_line33 = /*#__PURE__*/React.createElement("line", {
    opacity: 0.1,
    x1: 409,
    y1: 1147.5,
    x2: 389,
    y2: 1147.5,
    stroke: "#120232",
    strokeWidth: 3
  })), _line34 || (_line34 = /*#__PURE__*/React.createElement("line", {
    opacity: 0.1,
    x1: 409,
    y1: 1182.5,
    x2: 389,
    y2: 1182.5,
    stroke: "#120232",
    strokeWidth: 3
  })), _line35 || (_line35 = /*#__PURE__*/React.createElement("line", {
    opacity: 0.1,
    x1: 409,
    y1: 1217.5,
    x2: 389,
    y2: 1217.5,
    stroke: "#120232",
    strokeWidth: 3
  })), _line36 || (_line36 = /*#__PURE__*/React.createElement("line", {
    opacity: 0.1,
    x1: 409,
    y1: 1252.5,
    x2: 343,
    y2: 1252.5,
    stroke: "#6013FB",
    strokeWidth: 3
  })), _line37 || (_line37 = /*#__PURE__*/React.createElement("line", {
    opacity: 0.1,
    x1: 409,
    y1: 1287.5,
    x2: 389,
    y2: 1287.5,
    stroke: "#120232",
    strokeWidth: 3
  })), _line38 || (_line38 = /*#__PURE__*/React.createElement("line", {
    opacity: 0.1,
    x1: 409,
    y1: 1322.5,
    x2: 389,
    y2: 1322.5,
    stroke: "#120232",
    strokeWidth: 3
  })), _line39 || (_line39 = /*#__PURE__*/React.createElement("line", {
    opacity: 0.1,
    x1: 409,
    y1: 1357.5,
    x2: 389,
    y2: 1357.5,
    stroke: "#120232",
    strokeWidth: 3
  })), _line40 || (_line40 = /*#__PURE__*/React.createElement("line", {
    opacity: 0.1,
    x1: 409,
    y1: 1392.5,
    x2: 389,
    y2: 1392.5,
    stroke: "#120232",
    strokeWidth: 3
  })), _line41 || (_line41 = /*#__PURE__*/React.createElement("line", {
    opacity: 0.1,
    x1: 409,
    y1: 1427.5,
    x2: 374,
    y2: 1427.5,
    stroke: "#120232",
    strokeWidth: 3
  })), _line42 || (_line42 = /*#__PURE__*/React.createElement("line", {
    opacity: 0.1,
    x1: 409,
    y1: 1462.5,
    x2: 389,
    y2: 1462.5,
    stroke: "#120232",
    strokeWidth: 3
  })), _line43 || (_line43 = /*#__PURE__*/React.createElement("line", {
    opacity: 0.1,
    x1: 409,
    y1: 1497.5,
    x2: 389,
    y2: 1497.5,
    stroke: "#120232",
    strokeWidth: 3
  })), _line44 || (_line44 = /*#__PURE__*/React.createElement("line", {
    opacity: 0.1,
    x1: 409,
    y1: 1532.5,
    x2: 389,
    y2: 1532.5,
    stroke: "#120232",
    strokeWidth: 3
  })), _line45 || (_line45 = /*#__PURE__*/React.createElement("line", {
    opacity: 0.1,
    x1: 409,
    y1: 1567.5,
    x2: 389,
    y2: 1567.5,
    stroke: "#120232",
    strokeWidth: 3
  })), _line46 || (_line46 = /*#__PURE__*/React.createElement("line", {
    opacity: 0.1,
    x1: 409,
    y1: 1615.5,
    x2: 374,
    y2: 1615.5,
    stroke: "#120232",
    strokeWidth: 3
  })), _line47 || (_line47 = /*#__PURE__*/React.createElement("line", {
    opacity: 0.1,
    x1: 409,
    y1: 1650.5,
    x2: 389,
    y2: 1650.5,
    stroke: "#120232",
    strokeWidth: 3
  })), _line48 || (_line48 = /*#__PURE__*/React.createElement("line", {
    opacity: 0.1,
    x1: 409,
    y1: 1685.5,
    x2: 389,
    y2: 1685.5,
    stroke: "#120232",
    strokeWidth: 3
  })), _line49 || (_line49 = /*#__PURE__*/React.createElement("line", {
    opacity: 0.1,
    x1: 409,
    y1: 1720.5,
    x2: 389,
    y2: 1720.5,
    stroke: "#120232",
    strokeWidth: 3
  })), _line50 || (_line50 = /*#__PURE__*/React.createElement("line", {
    opacity: 0.1,
    x1: 409,
    y1: 1755.5,
    x2: 389,
    y2: 1755.5,
    stroke: "#120232",
    strokeWidth: 3
  })), _line51 || (_line51 = /*#__PURE__*/React.createElement("line", {
    opacity: 0.1,
    x1: 409,
    y1: 1790.5,
    x2: 343,
    y2: 1790.5,
    stroke: "#6013FB",
    strokeWidth: 3
  })), _line52 || (_line52 = /*#__PURE__*/React.createElement("line", {
    opacity: 0.1,
    x1: 409,
    y1: 1825.5,
    x2: 389,
    y2: 1825.5,
    stroke: "#120232",
    strokeWidth: 3
  })), _line53 || (_line53 = /*#__PURE__*/React.createElement("line", {
    opacity: 0.1,
    x1: 409,
    y1: 1860.5,
    x2: 389,
    y2: 1860.5,
    stroke: "#120232",
    strokeWidth: 3
  })), _line54 || (_line54 = /*#__PURE__*/React.createElement("line", {
    opacity: 0.1,
    x1: 409,
    y1: 1895.5,
    x2: 389,
    y2: 1895.5,
    stroke: "#120232",
    strokeWidth: 3
  })), _line55 || (_line55 = /*#__PURE__*/React.createElement("line", {
    opacity: 0.1,
    x1: 409,
    y1: 1930.5,
    x2: 389,
    y2: 1930.5,
    stroke: "#120232",
    strokeWidth: 3
  })), _line56 || (_line56 = /*#__PURE__*/React.createElement("line", {
    opacity: 0.1,
    x1: 409,
    y1: 1965.5,
    x2: 374,
    y2: 1965.5,
    stroke: "#120232",
    strokeWidth: 3
  })), _line57 || (_line57 = /*#__PURE__*/React.createElement("line", {
    opacity: 0.1,
    x1: 409,
    y1: 2000.5,
    x2: 389,
    y2: 2000.5,
    stroke: "#120232",
    strokeWidth: 3
  })), _line58 || (_line58 = /*#__PURE__*/React.createElement("line", {
    opacity: 0.1,
    x1: 409,
    y1: 2035.5,
    x2: 389,
    y2: 2035.5,
    stroke: "#120232",
    strokeWidth: 3
  })), _line59 || (_line59 = /*#__PURE__*/React.createElement("line", {
    opacity: 0.1,
    x1: 409,
    y1: 2070.5,
    x2: 389,
    y2: 2070.5,
    stroke: "#120232",
    strokeWidth: 3
  })), _line60 || (_line60 = /*#__PURE__*/React.createElement("line", {
    opacity: 0.1,
    x1: 409,
    y1: 2105.5,
    x2: 389,
    y2: 2105.5,
    stroke: "#120232",
    strokeWidth: 3
  })), _line61 || (_line61 = /*#__PURE__*/React.createElement("line", {
    opacity: 0.1,
    x1: 409,
    y1: 2153.5,
    x2: 374,
    y2: 2153.5,
    stroke: "#120232",
    strokeWidth: 3
  })), _line62 || (_line62 = /*#__PURE__*/React.createElement("line", {
    opacity: 0.1,
    x1: 409,
    y1: 2188.5,
    x2: 389,
    y2: 2188.5,
    stroke: "#120232",
    strokeWidth: 3
  })), _line63 || (_line63 = /*#__PURE__*/React.createElement("line", {
    opacity: 0.1,
    x1: 409,
    y1: 2223.5,
    x2: 389,
    y2: 2223.5,
    stroke: "#120232",
    strokeWidth: 3
  })), _line64 || (_line64 = /*#__PURE__*/React.createElement("line", {
    opacity: 0.1,
    x1: 409,
    y1: 2258.5,
    x2: 389,
    y2: 2258.5,
    stroke: "#120232",
    strokeWidth: 3
  })), _line65 || (_line65 = /*#__PURE__*/React.createElement("line", {
    opacity: 0.1,
    x1: 409,
    y1: 2293.5,
    x2: 389,
    y2: 2293.5,
    stroke: "#120232",
    strokeWidth: 3
  })), _line66 || (_line66 = /*#__PURE__*/React.createElement("line", {
    opacity: 0.1,
    x1: 409,
    y1: 2328.5,
    x2: 343,
    y2: 2328.5,
    stroke: "#6013FB",
    strokeWidth: 3
  })), _line67 || (_line67 = /*#__PURE__*/React.createElement("line", {
    opacity: 0.1,
    x1: 409,
    y1: 2363.5,
    x2: 389,
    y2: 2363.5,
    stroke: "#120232",
    strokeWidth: 3
  })), _line68 || (_line68 = /*#__PURE__*/React.createElement("line", {
    opacity: 0.1,
    x1: 409,
    y1: 2398.5,
    x2: 389,
    y2: 2398.5,
    stroke: "#120232",
    strokeWidth: 3
  })), _line69 || (_line69 = /*#__PURE__*/React.createElement("line", {
    opacity: 0.1,
    x1: 409,
    y1: 2433.5,
    x2: 389,
    y2: 2433.5,
    stroke: "#120232",
    strokeWidth: 3
  })), _line70 || (_line70 = /*#__PURE__*/React.createElement("line", {
    opacity: 0.1,
    x1: 409,
    y1: 2468.5,
    x2: 389,
    y2: 2468.5,
    stroke: "#120232",
    strokeWidth: 3
  })), _line71 || (_line71 = /*#__PURE__*/React.createElement("line", {
    opacity: 0.1,
    x1: 409,
    y1: 2503.5,
    x2: 374,
    y2: 2503.5,
    stroke: "#120232",
    strokeWidth: 3
  })), _line72 || (_line72 = /*#__PURE__*/React.createElement("line", {
    opacity: 0.1,
    x1: 409,
    y1: 2538.5,
    x2: 389,
    y2: 2538.5,
    stroke: "#120232",
    strokeWidth: 3
  })), _line73 || (_line73 = /*#__PURE__*/React.createElement("line", {
    opacity: 0.1,
    x1: 409,
    y1: 2573.5,
    x2: 389,
    y2: 2573.5,
    stroke: "#120232",
    strokeWidth: 3
  })), _line74 || (_line74 = /*#__PURE__*/React.createElement("line", {
    opacity: 0.1,
    x1: 409,
    y1: 2608.5,
    x2: 389,
    y2: 2608.5,
    stroke: "#120232",
    strokeWidth: 3
  })), _line75 || (_line75 = /*#__PURE__*/React.createElement("line", {
    opacity: 0.1,
    x1: 409,
    y1: 2643.5,
    x2: 389,
    y2: 2643.5,
    stroke: "#120232",
    strokeWidth: 3
  })), _line76 || (_line76 = /*#__PURE__*/React.createElement("line", {
    opacity: 0.1,
    x1: 409,
    y1: 2691.5,
    x2: 374,
    y2: 2691.5,
    stroke: "#120232",
    strokeWidth: 3
  })), _line77 || (_line77 = /*#__PURE__*/React.createElement("line", {
    opacity: 0.1,
    x1: 409,
    y1: 2726.5,
    x2: 389,
    y2: 2726.5,
    stroke: "#120232",
    strokeWidth: 3
  })), _line78 || (_line78 = /*#__PURE__*/React.createElement("line", {
    opacity: 0.1,
    x1: 409,
    y1: 2761.5,
    x2: 389,
    y2: 2761.5,
    stroke: "#120232",
    strokeWidth: 3
  })), _line79 || (_line79 = /*#__PURE__*/React.createElement("line", {
    opacity: 0.1,
    x1: 409,
    y1: 2796.5,
    x2: 389,
    y2: 2796.5,
    stroke: "#120232",
    strokeWidth: 3
  })), _line80 || (_line80 = /*#__PURE__*/React.createElement("line", {
    opacity: 0.1,
    x1: 409,
    y1: 2831.5,
    x2: 389,
    y2: 2831.5,
    stroke: "#120232",
    strokeWidth: 3
  })), _line81 || (_line81 = /*#__PURE__*/React.createElement("line", {
    opacity: 0.1,
    x1: 409,
    y1: 2866.5,
    x2: 343,
    y2: 2866.5,
    stroke: "#6013FB",
    strokeWidth: 3
  })), _line82 || (_line82 = /*#__PURE__*/React.createElement("line", {
    opacity: 0.1,
    x1: 409,
    y1: 2901.5,
    x2: 389,
    y2: 2901.5,
    stroke: "#120232",
    strokeWidth: 3
  })), _line83 || (_line83 = /*#__PURE__*/React.createElement("line", {
    opacity: 0.1,
    x1: 409,
    y1: 2936.5,
    x2: 389,
    y2: 2936.5,
    stroke: "#120232",
    strokeWidth: 3
  })), _line84 || (_line84 = /*#__PURE__*/React.createElement("line", {
    opacity: 0.1,
    x1: 409,
    y1: 2971.5,
    x2: 389,
    y2: 2971.5,
    stroke: "#120232",
    strokeWidth: 3
  })), _line85 || (_line85 = /*#__PURE__*/React.createElement("line", {
    opacity: 0.1,
    x1: 409,
    y1: 3006.5,
    x2: 389,
    y2: 3006.5,
    stroke: "#120232",
    strokeWidth: 3
  })), _line86 || (_line86 = /*#__PURE__*/React.createElement("line", {
    opacity: 0.1,
    x1: 409,
    y1: 3041.5,
    x2: 374,
    y2: 3041.5,
    stroke: "#120232",
    strokeWidth: 3
  })), _line87 || (_line87 = /*#__PURE__*/React.createElement("line", {
    opacity: 0.1,
    x1: 409,
    y1: 3076.5,
    x2: 389,
    y2: 3076.5,
    stroke: "#120232",
    strokeWidth: 3
  })), _line88 || (_line88 = /*#__PURE__*/React.createElement("line", {
    opacity: 0.1,
    x1: 409,
    y1: 3111.5,
    x2: 389,
    y2: 3111.5,
    stroke: "#120232",
    strokeWidth: 3
  })), _line89 || (_line89 = /*#__PURE__*/React.createElement("line", {
    opacity: 0.1,
    x1: 409,
    y1: 3146.5,
    x2: 389,
    y2: 3146.5,
    stroke: "#120232",
    strokeWidth: 3
  })), _line90 || (_line90 = /*#__PURE__*/React.createElement("line", {
    opacity: 0.1,
    x1: 409,
    y1: 3181.5,
    x2: 389,
    y2: 3181.5,
    stroke: "#120232",
    strokeWidth: 3
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLongTimeline);
export default __webpack_public_path__ + "static/media/LongTimeline.fca18484.svg";
export { ForwardRef as ReactComponent };